import dateModelValidator from 'forms/shared/validators/models/date/date';
import { getSafeDateTime } from 'helpers/date';
import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { DateModel, DateModelValidatorModel } from '../../models/date/types';
import { EmptyDate } from '../../models/date/instance';
import { BaseCustomValidator } from '../types';

const dateBaseValidator: BaseCustomValidator<DateModel> = (validateModel) => (
  argValue,
  options,
  attributeName,
  attributes,
  globalOptions
) => {
  const value = { ...EmptyDate(), ...argValue };
  const data: DateModelValidatorModel = {
    ...value,
    date: { ...value }, // This will get validated as a complete luxon date object
  };

  const newOptions = {
    requireDay: true,
    requireMonth: true,
    requireYear: true,
    ...globalOptions,
    ...options,
  };

  // In the scenario that earliest/latest are not valid dates, this will default
  // to DEFAULT_EARLIEST (200 years ago) and DEFAULT_LATEST (cannot be in the
  // future). Thus, validation will still occur (instead of no validation).
  newOptions.earliest = getSafeDateTime(newOptions.earliest).valid === true ? newOptions.earliest : DEFAULT_EARLIEST;
  newOptions.latest = getSafeDateTime(newOptions.latest).valid === true ? newOptions.latest : DEFAULT_LATEST;

  const errors = validateModel(data, dateModelValidator, newOptions);
  if (errors !== true) { return errors; }
  return null;
};

export default dateBaseValidator;
